module.exports = __webpack_public_path__ + "static/CertifiedDRSAgent-removebg-preview-91c5264acf5f86269f1debe98ecf64b7.png";